module.exports = __webpack_public_path__ + "static/media/checkmark-purple.60214560.svg";